import { Button } from "@mui/material";

type MenuButtonProps = {
  onClick?: VoidFunction;
  title: string;
  icon: React.ReactNode;
  hasData?: boolean;
};

export default function MenuButton({ onClick, title, icon, hasData }: MenuButtonProps) {
  return (
    <Button
      variant={'text'}
      onClick={onClick}
      sx={{
        mr: 1,
        color: hasData ? 'warning.main' : 'text.secondary',
        '&:hover': { backgroundColor: 'background.neutral' },
      }}
      startIcon={icon}
    >
      {title}
    </Button>
  );
}
